module.exports = __webpack_public_path__ + "images/Cross.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/Cross.png
// module id = 128
// module chunks = 0 1